// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"b43424e4","70":"2d35684b","156":"97bf2669","192":"f4008c1b","214":"fabec6e4","296":"fcd5af74","376":"95bd1da3","466":"bdd10669","519":"fe7c9f26","608":"957c15f4","718":"8fe384ec","793":"27806038","838":"c8f1d93b","933":"72199f37"}[chunkId] + ".chunk.js";
};